'use client';

import {
  IconButton,
  Avatar,
  Box,
  CloseButton,
  Flex,
  HStack,
  VStack,
  Icon,
  useColorModeValue,
  Text,
  Drawer,
  DrawerContent,
  useDisclosure,
  BoxProps,
  FlexProps,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Spinner,
  Image,
  Tooltip,
} from '@chakra-ui/react';
import {
  FiHome,
  FiTrendingUp,
  FiCompass,
  FiStar,
  FiSettings,
  FiMenu,
  FiBell,
  FiLogOut,
  FiChevronDown,
} from 'react-icons/fi';
import { MdInsights } from 'react-icons/md';
import { GrCompliance } from 'react-icons/gr';
import { LiaFlaskSolid } from 'react-icons/lia';
import { TbPackages } from 'react-icons/tb';


import { IconType } from 'react-icons';
import { Link, useLocation } from 'react-router-dom';
import PageRouter from '../routers/router';
import { useContext } from 'react';
import { Globle_app_context } from '../context/globle_context';
import companylogo from '../assets/img/Ologai_Logo_new.png';
// const logo='../assets/img/Ologai_Logo_new.png'
// import {} from
const LinkItems = [
  {
    comp_rout: 'home',
    routname: '/home',
    name: 'Ingredient Finder',
    icon: FiHome,
    tool_tip_disc:
      'Search and analyze ingredients for benefits, uses, and trends.',
  },
  {
    comp_rout: 'Formula Builder',
    routname: '#',
    name: 'Formula Builder',
    icon: LiaFlaskSolid,
    tool_tip_disc: 'Create and optimize custom hair care formulations.',
  },

  {
    comp_rout: 'Safety & Compliance',
    routname: '#',
    name: 'Safety & Compliance',
    icon: GrCompliance,
    tool_tip_disc: 'Ensure regulatory adherence for global markets.',
  },
  {
    comp_rout: 'Supplier Hub',
    routname: '#',
    name: 'Supplier Hub',
    icon: TbPackages,
    tool_tip_disc: 'Explore and compare verified ingredient suppliers.',
  },
  {
    comp_rout: 'Insights & Trends',
    routname: '#',
    name: 'Insights & Trends',
    icon: MdInsights,
    tool_tip_disc: 'Discover market trends and innovations in hair care.',
  },
];
const Logout_botton = ({
  routName,
  icon,
  children,
  is_active_rout,
  ...rest
}) => {
  const location = useLocation();
  const { SiginOut, logout_loading } = useContext(Globle_app_context);

  return (
    <Box style={{ textDecoration: 'none' }} _focus={{ boxShadow: 'none' }}>
      <Flex
        align="center"
        p="2"
        mx="2"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        // _hover={{
        //   // bg: 'gray.400',
        //   color: is_active_rout ? 'white' : '#e4d0e9',
        // }}
        bg={is_active_rout ? '#e4d0e9' : 'white'}
        color="black"
        {...rest}
      >
        {icon && (
          <Icon
            mr="4"
            fontSize="16"
            // _groupHover={{
            //   color: is_active_rout ? 'white' : '#e4d0e9',
            // }}
            as={icon}
          />
        )}
        {children}
      </Flex>
    </Box>
  );
};

const SidebarContent = ({ onClose, ...rest }) => {
  const location = useLocation();
  const { SiginOut, logout_loading } = useContext(Globle_app_context);
  // const tool_tip_bg_color_var = tool_tip_bg_color
  return (
    <Box
      transition="3s ease"
      className="translate-y-[-5px]"
      bg={useColorModeValue('white', 'gray.900')}
      borderRight="1px"
      borderRightColor={useColorModeValue('gray.200', 'gray.700')}
      w={{ base: 'full', md: 60 }}
      pos="fixed"
      h="full"
      {...rest}
    >
      <Flex h="14" alignItems="center" mx="8" justifyContent="space-between">
        <Image
          className="w-[50%]"
          objectFit="cover"
          src={companylogo}
          alt="Dan Abramov"
        />

        {/* <Text fontSize="2xl" fontFamily="monospace" fontWeight="">
          OLOGAI
        </Text> */}
        <CloseButton display={{ base: 'flex', md: 'none' }} onClick={onClose} />
      </Flex>
      <div className="pt-[16px]"></div>
      {LinkItems.map((link) => (
        <>
          <NavItem
            is_active_rout={location.pathname
              .split('/')
              .includes(link.comp_rout)}
            routName={link.routname}
            key={link.name}
            icon={link.icon}
            text="white"
            className="font-normal text-white  "
          >
            <Tooltip
              label={link?.tool_tip_disc}
              placement="right"
              bg={`white`}
              textColor={'black'}
              border="1px solid"
              borderRadius="md"
              borderColor="#c2c2c2"
              boxShadow={'2px 2px #51bcfa'}
              p="2"
              fontWeight={'normal'}

              //      const baseStyle = {
              //   borderRadius: 'md', // add a border radius
              //   fontWeight: 'normal', // change the font weight
              //   border: '1px solid', // add a border
              // }
            >
              <p
                className={`${
                  location.pathname.split('/').includes(link.comp_rout)
                    ? 'text-white'
                    : 'text-black'
                } text-[15px] side_bar_menu `}
              >
                {link.name}
              </p>
            </Tooltip>
          </NavItem>
        </>
      ))}
      <hr />

      {/* <Logout_botton onClick={SiginOut} icon={FiLogOut}>
        Logout
      </Logout_botton> */}
    </Box>
  );
};

const NavItem = ({ routName, icon, children, is_active_rout, ...rest }) => {
  const location = useLocation();

  return (
    <Link to={routName}>
      <Box
        as="a"
        href="#"
        style={{ textDecoration: 'none' }}
        _focus={{ boxShadow: 'none' }}
      >
        <Flex
          align="center"
          p="2"
          mx="2"
          borderRadius="lg"
          role="group"
          cursor="pointer"
          // _hover={{
          //   // bg: 'gray.400',
          //   color: is_active_rout ? 'white' : '#e4d0e9',
          // }}
          bg={is_active_rout ? '#51bcfa' : 'white'}
          color="black"
          {...rest}
        >
          {icon && (
            <Icon
              mr="4"
              fontSize="16"
              // _groupHover={{
              //   color: is_active_rout ? 'white' : '#e4d0e9',
              // }}
              as={icon}
              color={is_active_rout ? 'white' : 'black'}
            />
          )}
          {children}
        </Flex>
      </Box>
    </Link>
  );
};

const MobileNav = ({ onOpen, ...rest }) => {
  const { SiginOut, logout_loading } = useContext(Globle_app_context);
  const location = useLocation();
  return (
    <Flex
      className="sticky  top-[0px] z-[200] h-[70.5px]  "
      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 4 }}
      alignItems="center"
      bg={useColorModeValue('white', 'gray.900')}
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
      justifyContent={{ base: 'space-between', md: 'flex-end' }}
      {...rest}
    >
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant="outline"
        aria-label="open menu"
        icon={<FiMenu />}
      />

      {/* <Text
        display={{ base: 'flex', md: 'none' }}
        fontSize="2xl"
        fontFamily="monospace"
        fontWeight=""
      >
        OLOGAI
      </Text> */}
      <Image
        display={{ base: 'flex', md: 'none' }}
        className="w-[18%]"
        objectFit="cover"
        src={companylogo}
        alt="Dan Abramov"
      />

      <HStack spacing={{ base: '0', md: '6' }}>
        <Flex alignItems={'center'}>
          <Menu>
            <MenuButton
              py={2}
              transition="all 0.3s"
              _focus={{ boxShadow: 'none' }}
            >
              <HStack>
                <Avatar
                  size={'sm'}
                  src={
                    'https://images.unsplash.com/photo-1619946794135-5bc917a27793?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=b616b2c5b373a80ffc9636ba24f7a4a9'
                  }
                />
                <VStack
                  display={{ base: 'none', md: 'flex' }}
                  alignItems="flex-start"
                  spacing="1px"
                  ml="2"
                >
                  <Text fontSize="sm">User</Text>
                  <Text fontSize="xs" color="gray.600">
                    Admin
                  </Text>
                </VStack>
                <Box display={{ base: 'none', md: 'flex' }}>
                  <FiChevronDown />
                </Box>
              </HStack>
            </MenuButton>
            <MenuList
              bg={useColorModeValue('white', 'gray.900')}
              borderColor={useColorModeValue('gray.200', 'gray.700')}
            >
              <MenuItem>Profile</MenuItem>
              <MenuDivider />
              {logout_loading ? (
                <div className="flex justify-center">
                  <Spinner />
                </div>
              ) : (
                <MenuItem onClick={SiginOut}>Sign out</MenuItem>
              )}
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </Flex>
  );
};

export default function SidebarWithHeader() {
  const location = useLocation();
  console.log(location);
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box minH="100vh" bg={'white'}>
      {location.pathname == '/signin' || location.pathname == '/signup' ? (
        <PageRouter />
      ) : (
        <>
          <SidebarContent
            onClose={() => onClose}
            display={{ base: 'none', md: 'block' }}
          />
          <Drawer
            isOpen={isOpen}
            placement="left"
            onClose={onClose}
            returnFocusOnClose={false}
            onOverlayClick={onClose}
            size="full"
          >
            <DrawerContent>
              <SidebarContent onClose={onClose} />
            </DrawerContent>
          </Drawer>
          {/* mobilenav */}
          <MobileNav onOpen={onOpen} />

          <Box className="bg-[white] mt-0 pt-0 p-4 " ml={{ base: 0, md: 60 }}>
            <PageRouter />
          </Box>
        </>
      )}
    </Box>
  );
}

// const searchClient = algoliasearch(
//   "6K28WYSFRG",
//   "7a65b31fc9b4147e0a19aa33f28a576f",
// );

// const search = instantsearch({
//   indexName: "raw_materials"
